import React from "react";
import "../../styles/About.css";
import AboutImg from "../../assets/images/aboutd.png";
import { Link } from "react-router-dom";

function Aboutbanner() {
  return (
    <div>
      <section className="About-banner">
        <div className="About-banner-content">
          <h1>About Empower Web – Your Growth Partner for High-Converting Websites </h1>
          <p>
            Every great journey begins with a small step. The story of Empower
            Web is no different it has begun with a passion, vision and an
            unshakable belief.
    
            Technology, design and digital marketing usually felt complicated
            and out of reach. 
          </p>
          <Link to="/contact">
            <button className="blogall-btn">Get Free Consultation →</button>
          </Link>
        </div>
        <div className="About-banner-image">
          <img src={AboutImg} alt="Business Growth" />
        </div>
      </section>
      <div>
        <div className="breadcrumb">
          <Link to="/">Home</Link>
          <span> / </span>
          <span>About us</span>
        </div>
      </div>
    </div>
  );
}

export default Aboutbanner;
